import styled, { css } from 'styled-components';
import { variants, th } from 'style/theme';

export const ToggleLabel = styled.label`
  position: absolute;
  left: 0;
  top: 0;
  display: inline-block;
  width: 50px;
  height: 17px;
  vertical-align: middle;
  border-radius: 15px;
  transition: 0.4s;
  background: #c4c4c4;
  cursor: ${(p) => (p.disabled ? 'default' : 'pointer')};
  &::after {
    position: absolute;
    content: '';
    box-sizing: border-box;
    height: 25px;
    width: 25px;
    left: 0px;
    bottom: -3.5px;
    background-color: white;
    transition: 0.4s;
    border-radius: 50%;
    box-shadow: 0px 3px 6px #00000029;
    border: 2px solid #f0f0f0;
  }

  ${variants('variant', {
    rh: css`
      background: color: ${th('colors.blueGray4')};
      width: 40px;
      height: 24px;

      &::after {
        bottom: 4px;
        left: 4px;
        height: 16px;
        width: 16px;
      }
    `
  })}
`;

export const ReadMoreToggleLabel = styled(ToggleLabel)`
  top: 5px;
`;

export const StyledToggle = styled.input`
  position: absolute;
  opacity: 0;
  z-index: 1;
  border-radius: 15px;
  width: 50px;
  height: 17px;
  margin: 0;
  cursor: ${(p) => (p.disabled ? 'default' : 'pointer')};

  &:checked + ${ToggleLabel} {
    background: #7addb6;
    &::after {
      transform: translateX(26px);
    }

    ${variants('variant', {
      rh: css`
        &::after {
          transform: translateX(16px);
        }
      `
    })}
  }
`;

export const Container = styled.div`
  display: flex;
  position: relative;
  ${variants('variant', {
    rh: css`
      height: 24px;
      width: 40px;
      margin: 0;
    `
  })}
`;

export const ToggleText = styled.div`
  ${variants('variant', {
    light: css`
      color: ${th('colors.white')};
    `,
    dark: css`
      color: ${th('colors.black')};
    `
  })}

  margin: -1px 0 0 60px;
  line-height: 18px;
`;

export const ReadMoreToggleText = styled(ToggleText)`
  line-height: 26px;
  white-space: pre-line;
`;

export const ReadMore = styled.span`
  margin-left: 6px;
  color: ${th('colors.turquoise')};
  text-decoration: underline;
  cursor: pointer;
`;
